const MIN_PLAYER_WIDTH = 280;
const PORTRAIT_HEIGHT_RATIO = 16 / 9;
const FRAME_PROPERTIES = [
    '--vt-frame-width', '--vt-frame-height', '--vt-frame-scale',
    '--vt-frame-left', '--vt-frame-top'
];

/**
 * Fits a VT portrait iframe, including its reported controls height, into its card.
 * @param {HTMLIFrameElement} playerIframe
 * @returns {() => void} Releases frame sizing and its listeners.
 */
export function attachPortraitFrame(playerIframe) {
    const playerContainer = playerIframe.parentElement;
    const isVtPortrait = playerContainer.classList.contains('portrait-mode') &&
        playerContainer.closest('.vt-video-wrapper') !== null;
    if (!isVtPortrait) return function releaseUnusedFrame() {};

    let contentHeightRatio = PORTRAIT_HEIGHT_RATIO;
    let frameWidth = MIN_PLAYER_WIDTH;

    function resizeFrame() {
        const availableWidth = playerContainer.clientWidth;
        const availableHeight = playerContainer.clientHeight;
        if (availableWidth === 0 || availableHeight === 0) return;

        frameWidth = Math.max(MIN_PLAYER_WIDTH, availableWidth);
        const frameHeight = frameWidth * contentHeightRatio;
        const frameScale = Math.min(availableWidth / frameWidth, availableHeight / frameHeight);
        playerIframe.style.setProperty('--vt-frame-width', `${frameWidth}px`);
        playerIframe.style.setProperty('--vt-frame-height', `${frameHeight}px`);
        playerIframe.style.setProperty('--vt-frame-scale', String(frameScale));
        playerIframe.style.setProperty('--vt-frame-left', `${(availableWidth - frameWidth * frameScale) / 2}px`);
        playerIframe.style.setProperty('--vt-frame-top', `${(availableHeight - frameHeight * frameScale) / 2}px`);
    }

    function handlePlayerMessage(event) {
        const playerOrigin = new URL(playerIframe.src, window.location.href).origin;
        if (event.source !== playerIframe.contentWindow || event.origin !== playerOrigin) return;
        let playerMessage = event.data;
        if (typeof playerMessage === 'string') {
            try {
                playerMessage = JSON.parse(playerMessage);
            } catch (error) {
                return;
            }
        }
        if (!playerMessage || typeof playerMessage !== 'object' || Array.isArray(playerMessage)) return;

        const reportedHeight = Number(playerMessage.body_height || playerMessage.height);
        if (!Number.isFinite(reportedHeight) || reportedHeight <= 0) return;
        contentHeightRatio = Math.max(PORTRAIT_HEIGHT_RATIO, reportedHeight / frameWidth);
        resizeFrame();
    }

    playerIframe.classList.add('vt-portrait-iframe');
    window.addEventListener('message', handlePlayerMessage);
    window.addEventListener('resize', resizeFrame);
    playerIframe.addEventListener('load', resizeFrame);
    let containerObserver = null;
    if (window.ResizeObserver) {
        containerObserver = new window.ResizeObserver(resizeFrame);
        containerObserver.observe(playerContainer);
    }
    resizeFrame();

    return function releasePortraitFrame() {
        if (containerObserver) containerObserver.disconnect();
        window.removeEventListener('message', handlePlayerMessage);
        window.removeEventListener('resize', resizeFrame);
        playerIframe.removeEventListener('load', resizeFrame);
        playerIframe.classList.remove('vt-portrait-iframe');
        FRAME_PROPERTIES.forEach(function removeFrameProperty(propertyName) {
            playerIframe.style.removeProperty(propertyName);
        });
    };
}



// WEBPACK FOOTER //
// ./src/components/vehicle-test/portrait-frame.js